<fm-dialog #dialog1 header="Upload Files" [(visible)]="display1" modal="modal" [width]="1250"
           [responsive]="true" [dismissableMask]="false" (onHide)="onHide()" (onShow)="onShow()">
  <fm-loading-spinner [isLoading]="isLoading"></fm-loading-spinner>
  <br>
  <div class="progress-bar">
    <div class="split-left" [class.selected-tab]="currentStep=='UploadFileStep'"
         [class.not-selected-tab]="currentStep=='ReviewFileSummaryStep'" (click)="backToUpload()">
      Upload Files
    </div>
    <div class="split-right" [class.selected-tab]="currentStep=='ReviewFileSummaryStep'"
         [class.not-selected-tab]="currentStep=='UploadFileStep'" (click)="backToReview()">
      Review File Summary
    </div>
  </div>
  <br>
  <div id="uploadFilesTab" *ngIf="currentStep=='UploadFileStep'">
    <fm-header-template>
      <p>The system will scan your files for viruses, correct naming conventions, <br> and data errors to ensure
        they
        are eligible to submit.</p>
    </fm-header-template>
    <div id="enabledUploadComponent" *ngIf="!fileUploadService.disableUpload && !isMAUser">
      <fm-s3-fileupload (onSelect)="onSelectFile($event)" (onFileUploadSubmit)="completeFileUpload($event)"
                        (onUpload)="onUploadFile($event)"
                        (onClear)="fileUploadService.onClearFile()" (finalMetaData)="onContinue()"
                        appCode="mfdstdn" showUploadButton="true"
                        showCancelButton="true" chooseLabel="Select File(s)" multiple="true"
                        uploadLabel="Start Upload"
                        cancelLabel="Remove All" continueLabel="Continue" mode="advanced"
                        [maxFileSize]="AppConstants.MAX_FILE_UPLOAD_SIZE"
                        [displayMessage]="AppConstants.MAX_FILE_UPLOAD_SIZE_MSG" cdx="true"
                        accept=".xml,.csv,.XML,.CSV,.xML,.cSV,.XmL,.CsV,.XMl,.CSv,.Xml,.Csv,.xMl,.cSv,.xmL,.csV">
      </fm-s3-fileupload>
    </div>
    <div id="enabledUploadComponent" *ngIf="!fileUploadService.disableUpload && isMAUser">
      <fm-s3-fileupload (onSelect)="onSelectFile($event)" (onFileUploadSubmit)="completeFileUpload($event)"
                        (onUpload)="onUploadFile($event)"
                        (onClear)="fileUploadService.onClearFile()" (finalMetaData)="onContinue()"
                        appCode="mfdstdn" showUploadButton="true"
                        showCancelButton="true" chooseLabel="Select File(s)" multiple="true" uploadLabel="Start Upload"
                        cancelLabel="Remove All" continueLabel="Continue" mode="advanced"
                        [maxFileSize]="AppConstants.MAX_FILE_UPLOAD_SIZE"
                        [displayMessage]="AppConstants.MAX_FILE_UPLOAD_SIZE_MSG" cdx="true"
                        accept=".csv,.CSV,.cSV,.CsV,.CSv,.Csv,.cSv,.csV">
      </fm-s3-fileupload>
    </div>
    <div id="disabledUploadComponent" *ngIf="fileUploadService.disableUpload">
      <fm-s3-fileupload (onSelect)="onSelectFile($event)" (onFileUploadSubmit)="completeFileUpload($event)"
                        (onUpload)="onUploadFile($event)"
                        (onClear)="fileUploadService.onClearFile()" (finalMetaData)="onContinue()"
                        appCode="mfdstdn" showUploadButton="false"
                        showCancelButton="true" chooseLabel="Select File(s) - DISABLED" multiple="true"
                        uploadLabel="Start Upload" cancelLabel="Remove All" continueLabel="Continue" mode="advanced"
                        [maxFileSize]="AppConstants.MAX_FILE_UPLOAD_SIZE"
                        [displayMessage]="AppConstants.MAX_FILE_UPLOAD_SIZE_MSG" cdx="true"
                        accept=".xml,.csv,.XML,.CSV,.xML,.cSV,.XmL,.CsV,.XMl,.CSv,.Xml,.Csv,.xMl,.cSv,.xmL,.csV">
      </fm-s3-fileupload>
    </div>
  </div>
  <div id="reviewFilesTab" *ngIf="currentStep=='ReviewFileSummaryStep'">
    <div *ngIf="!showIssueSummaryPreview">
      <fm-table id="fileUploadComponentTable" [columns]="cols" [value]="uploadedFiles" scrollable="true" scrollHeight="{{modalTableHeight}}"
            sortMode="single" selectionMode="multiple" [selection]="selectedFilesArray" (selectionChange)="onSubmitSelection($event)" lazy="true">
        <ng-template fmTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [fmSortableColumn]="col.field">{{ col.header }}
              <fm-sortIcon [field]="col.field"></fm-sortIcon>
            </th>
            <th class="checkboxHeader">
              <label class="select-all-submit-label">
                <b>Select to Submit</b>
                <input type="checkbox"
                       style="margin-left: 8px; position: relative; top: 1px;"
                       [checked]="selectAllToSubmit"
                       [disabled]="getEligibleFiles().length === 0"
                       (change)="onSelectAllToSubmitChange($event)">
              </label>
            </th>
          </tr>
        </ng-template>
        <ng-template fmTemplate="body" let-rowData let-columns="columns">
          <tr align="center" [fmSelectableRow]="rowData">
            <td *ngFor="let col of columns" (click)="showIssueSummaryPage(rowData)"
                [ngClass]="{'issue-summary' : rowData[col.field].includes('errors;')}">
              <i *ngIf="rowData[col.field]=='Ready to submit'" class="fmi fmi-check-circle accepted"
                 aria-hidden="true"></i>
              <i *ngIf="rowData[col.field]=='Acceptable with warnings'"
                 class="fmi fmi-exclamation-circle warning" aria-hidden="true"></i>
              <i *ngIf="rowData[col.field]=='Not acceptable'" class="fmi fmi-times-circle rejected"
                 aria-hidden="true"></i>
              <i *ngIf="rowData[col.field]=='Error'" class="fmi fmi-times-circle rejected"
                 aria-hidden="true"></i>
              {{ rowData[col.field] }}
            </td>
            <td class="checkbox">
              <fm-tableCheckbox [value]="rowData"
                                *ngIf="rowData.status=='Ready to submit'||rowData.status=='Acceptable with warnings'">
              </fm-tableCheckbox>
            </td>
          </tr>
        </ng-template>
      </fm-table>
      <div id="noFilesUploaded" align="center" *ngIf="uploadedFiles.length === 0">
        <br>
        No files were uploaded.
      </div>

      <br>

      <div style="text-align: left">
        <button fmButton type="button" label="Back To Upload" (click)="backToUpload()"
                class="back-upload-button"></button>
      </div>
      <div class="finish-close-button" *ngIf="selectFilesTouched || !finishAndCloseClicked">
        <i class="submissionText">Selected files will be submitted upon completion, others will be discarded</i>
        <button fmButton type="button" [primary]="true" label="Finish And Close"
                (click)="finishAndClose()"></button>
      </div>
      <div class="finish-close-button" *ngIf="!selectFilesTouched && finishAndCloseClicked">
        <i class="submissionText">Are you sure you want to exit without submitting file(s)?</i>
        <button fmButton class="yes-button" type="button" [primary]="true" label="Yes"
                (click)="continueSubmission()"></button>
      </div>
    </div>
  </div>
  <fm-confirmDialog id="uploadErrorModal" class="uploadErrorModal" key="confirm" [alignLeft]="true"
                    acceptLabel="Back To Upload" [width]="1250" [height]="750">
  </fm-confirmDialog>
  <div id="issueSummaryPreviewPage" *ngIf="showIssueSummaryPreview">
    <app-issue-summary-preview></app-issue-summary-preview>
  </div>
</fm-dialog>
